import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

import type {
  FlowCallMusicSplitPayloadT,
  FlowCallUploadFilePayloadT,
} from '../../holdMusic/components/types';

export const waitMusicActions = createActions(
  {
    WAIT_MUSIC_GET_ALL: [
      (payload: void) => payload,
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    WAIT_MUSIC_UPLOAD: [
      (payload: FlowCallUploadFilePayloadT) => payload,
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    WAIT_MUSIC_SPLIT: [
      (payload: FlowCallMusicSplitPayloadT) => payload,
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },
  'WAIT_MUSIC_GET_ALL_SUCCEEDED',
  'WAIT_MUSIC_GET_ALL_FAILED',
  'WAIT_MUSIC_UPLOAD_SUCCEEDED',
  'WAIT_MUSIC_UPLOAD_FAILED',
  'WAIT_MUSIC_SPLIT_SUCCEEDED',
  'WAIT_MUSIC_SPLIT_FAILED',
  'WAIT_MUSIC_SELECT',
  'WAIT_MUSIC_RESET',
  'WAIT_MUSIC_SHOW_MODAL',
  'WAIT_MUSIC_HIDE_MODAL',
  'WAIT_MUSIC_WS_UPLOAD_STATUS',
  'WAIT_MUSIC_WAITING_FOR_SPLITING_OPEN',
  'WAIT_MUSIC_WAITING_FOR_SPLITING_CLOSE',
);
